import { BillingSetting } from "../../classes";

const BillingSettingModule = {
  namespaced: true,
  state: {
    billingSettings: []
  },
  actions: {
    createBillingSetting: async ({ commit, dispatch, rootGetters }, payload) => {
      try {
        payload.accountingProductId = payload.accountingProductId
        payload.cost = parseFloat(payload.cost)
        payload.discount = parseFloat(payload.discount)
        payload.originalDiscount = parseFloat(payload.originalDiscount)
        payload.marketId = rootGetters["markets/getMarketId"]
        const data = await BillingSetting.createBillingSetting(payload);
        // dispatch("getBillingSettings", { areaId: payload.areaId });
        return data;
      } catch (err) {

        throw err;
      }
    },
    getBillingSettings: async ({ commit }, payload) => {
      try {
        const data = await BillingSetting.getBillingSettings({
          areaId: payload.areaId
        });
        commit("setBillingSettings", { billingSettings: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateBillingSetting: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const dataNormalization = {
          id: payload.id,
          accountingProductId: payload.accountingProductId,
          type: payload.type,
          cost: parseFloat(payload.cost),
          minimumCost: payload.type == 'step' || payload.type == 'minimum_unit' || payload.type == 'minimum_cost' ? parseFloat(payload.minimumCost) : undefined,
          minimumUnit: payload.type == 'step' || payload.type == 'minimum_unit' || payload.type == 'minimum_cost' ? parseFloat(payload.minimumUnit) : undefined,
          discountType: payload.discountType,
          discount: parseFloat(payload.discount),
          originalDiscount: parseFloat(payload.originalDiscount),
          step: payload.step,
        };
        const data = await BillingSetting.updateBillingSetting(
          dataNormalization
        );
        // dispatch("getBillingSettings", { areaId: payload.area.objectId });
        return data;
      } catch (err) {
        return false;
      }
    },
    removeBillingSetting: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const id = payload.id;
        const { data, status } = await BillingSetting.removeBillingSetting({
          id: id
        });
        return data;
      } catch (err) {
        return false;
      }
    },
    getBillingSettingsByAreas: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await BillingSetting.getBillingSettingsByAreas(payload);
        commit("setBillingSettings", { billingSettings: data });
        return data;
      } catch (err) {
        return false;
      }
    },
    getBillingSettingsByMeters: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await BillingSetting.getBillingSettingsByMeters(payload);
        commit("setBillingSettings", { billingSettings: data });
        return data;
      } catch (err) {
        return false;
      }
    },
  },
  getters: {
    getBillingSettings: state => state.billingSettings,
    getBillingSettingsQuantity: state => {
      return state.billingSettings.filter(( d )=> d.type == 'quantity')
    },
    getBillingSettingsWithLabel: state => {
      return state.billingSettings.map(item => {
        if (item.accountingProduct) {
          item.accountingProductId = item.accountingProduct.objectId;
          return item
        }
      });
    }
  },
  mutations: {
    setBillingSettings: (state, payload) => {
      state.billingSettings = payload.billingSettings;
    }
  }
};

export default BillingSettingModule;
